export default function getResource(label) {
    const resources = {
        movedToSaveForLater: 'has been moved to',
        saveForLater: 'Save for Later',
        gotIt: 'Got It',
        undo: 'Undo',
        viewSavedItems: 'View saved items',
        moveBackToBasket: 'Move back to basket',
        confirmationAriaLabel: 'saved for later confirmation'
    };

    return resources[label];
}
